import { ESeparateWallType } from '@/editor/data/separateWall/SeparateWall';
import { ERegionType, ERoomType } from '@/editor/data/type';
import i18next from '@/i18n';

export const SEPARATE_WALL_NAME_BY_TYPE: Partial<Record<ESeparateWallType, string>> = {
  [ESeparateWallType.VirtualWall]: i18next.t('partition.class.virtualpartition'),
  [ESeparateWallType.SolidTabletWall]: i18next.t('partition.class.solidwall'),
  [ESeparateWallType.HalfGlassWall]: i18next.t('partition.class.halfglasswall'),
  [ESeparateWallType.GlassWall]: i18next.t('partition.class.glasswall')
} as const;

export const ROOM_NAME_BY_TYPE: Record<ERoomType, string> = {
  [ERoomType.Default]: i18next.t('draw.house.parameters.unname'),
  [ERoomType.Office]: i18next.t('draw.house.parameters.office'),
  [ERoomType.CorridorPassage]: i18next.t('draw.house.parameters.corridor'),
  [ERoomType.ElevatorRoom]: i18next.t('draw.house.parameters.elevator'),
  [ERoomType.Toilet]: i18next.t('draw.house.parameters.toilet'),
  [ERoomType.Warehouse]: i18next.t('draw.house.parameters.storage'),
  [ERoomType.EquipmentRoom]: i18next.t('draw.house.parameters.equipmentroom'),
  [ERoomType.OtherRoom]: i18next.t('draw.other')
} as const;

export const REGION_NAME_BY_TYPE: Record<ERegionType, string> = {
  [ERegionType.Default]: i18next.t('draw.house.parameters.unname'),
  [ERegionType.Workspace]: i18next.t('draw.layout.tool.work'),
  [ERegionType.RestArea]: i18next.t('draw.layout.tool.loungearea'),
  [ERegionType.DiscussionForum]: i18next.t('draw.layout.tool.discuss'),
  [ERegionType.SingleRoom]: i18next.t('draw.layout.tool.cell'),
  [ERegionType.ReceptionRoom]: i18next.t('draw.layout.tool.reception'),
  [ERegionType.EquipmentRoom]: i18next.t('draw.house.parameters.equipmentroom'),
  [ERegionType.Anteroom]: i18next.t('draw.layout.tool.frontroom'),
  [ERegionType.Reception]: i18next.t('draw.layout.tool.frontdesk'),
  [ERegionType.Lounge]: i18next.t('draw.layout.tool.lounge'),
  [ERegionType.StorageRoom]: i18next.t('draw.layout.tool.storage'),
  [ERegionType.NetworkRoom]: i18next.t('draw.layout.tool.netroom'),
  [ERegionType.OtherRoom]: i18next.t('draw.other'),
  [ERegionType.Aisle]: i18next.t('draw.layout.tool.aisle')
};

export const ROOM_TYPE = i18next.t('draw.house.parameters.roomtype');
